import {HealthNotice} from "../components/HealthNotice";
import {Button} from "../components/Button";
import {ProgramCard} from "../components/ProgramCard";
import {SectionHeading} from "../components/SectionHeading";
import {featuredPrograms} from "../data/programs";
import {aboutParagraphs, associationObjectives} from "../data/about";
import {routeHref} from "../routes";
import "./HomePage.scss";

function AboutSection({ asPage = false }: { asPage?: boolean }) {
  return (
      <section className="about-section" id="despre-noi" aria-labelledby="about-title">
        <div className="page-container">
          <div className="about-section__heading">
            <p className="eyebrow">ASOCIAȚIA · DIN 2011</p>
            {asPage ? <h1 id="about-title">Despre noi</h1> : <h2 id="about-title">Despre noi</h2>}
          </div>
          <div className="about-section__body">
            <div className="about-section__story">
              {aboutParagraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
            </div>
            <div className="about-section__objectives">
              <h3>Obiectivele asociației</h3>
              <p>Solicităm sprijinul Dumneavoastră pentru a putea materializa obiectivele asociației, respectiv:</p>
              <ul>
                {associationObjectives.map(objective => <li key={objective}>{objective}</li>)}
              </ul>
              <p className="about-section__membership">Persoanele care doresc să primească calitatea de membre ale
                asociației, pot semnala către asociație această intenție a lor prin completarea <a
                  href={routeHref("/contact")}>formularului de contact</a>, urmând a fi contactate pentru detalii.</p>
            </div>
          </div>
          <HealthNotice/>
        </div>
      </section>
  );
}

export function HomePage({ aboutOnly = false }: { aboutOnly?: boolean }) {
  if (aboutOnly) return <AboutSection asPage />;
  return (
    <>
      <section className="home-hero">
        <div className="page-container home-hero__inner">
          <div className="home-hero__content">
            <p className="eyebrow eyebrow--lime">A.U.P.P.S. PERSONOCRAȚIA</p>
            <h1>Cunoașterea ne eliberează<br/>și ne vindecă</h1>
            <p className="home-hero__lead">A supraviețui sau a trăi cu adevărat?</p>
            <div className="home-hero__actions">
              <Button href="/ateliere/" variant="secondary">Descoperă atelierele</Button>
            </div>
            <a className="home-hero__tax-link eyebrow eyebrow--lime"
               href="https://formular230.ro/asociatia-pentru-promovarea-sanatatii-personocratia" target="_blank"
               rel="noreferrer">Redirecționează 3,5% gratuit din impozitul tău ↗</a>
          </div>
          <div className="home-hero__visual">
            <picture className="home-hero__picture">
              <source srcSet="/assets/acasa/home-hero-wellbeing.fe60f4ee.webp" type="image/webp"/>
              <img className="home-hero__image" src="/assets/acasa/home-hero-wellbeing.png"
                   width="532" height="1372" fetchPriority="high"
                   alt="Portret ilustrat al unei femei, cu motive botanice și anatomice aurii pe fundal montan"/>
            </picture>
          </div>
        </div>
      </section>

      <AboutSection />

      <section className="featured-programs-section">
        <div className="page-container">
          <SectionHeading eyebrow="PROGRAME DIN COMUNITATE"
                          action={<a href={routeHref("/ateliere")}>Toate programele ↗</a>}>
            <span className="desktop-only">Programe cu forme diferite.<br/>Același respect pentru oameni.</span>
            <span className="mobile-only">Programe pentru<br/>povești diferite.</span>
          </SectionHeading>
          <div className="program-grid">
            {featuredPrograms.map((program, index) => <ProgramCard key={program.slug || `${program.image}-${index}`}
                                                                   program={program} compact/>)}
          </div>
        </div>
      </section>

      <section className="home-testimonial">
        <div className="page-container home-testimonial__inner">
          <div>
            <p className="eyebrow desktop-only">POVEȘTI REALE · DIN COMUNITATE</p>
            <p className="eyebrow mobile-only">DIN COMUNITATE</p>
            <h2 className="desktop-only">Ce rămâne cu noi<br/>sunt oamenii.</h2>
            <a className="text-link desktop-only" href={routeHref("/testimoniale")}>Vezi testimonialele ↗</a>
          </div>
          <blockquote>
            <span aria-hidden="true" className="quote-mark desktop-only">“</span>
            <p>Am simțit că aparțin de cineva.</p>
            <cite>Corina · <span className="desktop-only">participantă</span><span
              className="mobile-only">2017</span></cite>
            <a className="text-link mobile-only" href={routeHref("/testimoniale")}>Vezi testimonialele ↗</a>
          </blockquote>
        </div>
      </section>
    </>
  );
}
